export const API_CONFIG = {
  BASE_URL: 'https://tbl.zerdegroup.kz/api',
  FACE_ID_URL: 'http://192.168.1.21:8001/AccountingTable',
  TIMEOUT: 5000,
} as const;

export const APP_CONFIG = {
  VERSION: 'v1.8',
  SERVER_STATUS_CHECK_INTERVAL: 30000,
  REMEMBER_ME_EXPIRES_DAYS: 1000,
} as const;

export const ROUTES = {
  ADMIN: '/admin',
  DASHBOARD: '/dashboard',
} as const;

export const ADMIN_ROLES = ['admin', 'moder', 'view', 'guide', 'km', 'to', 'full-report'] as const;
